// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6892f77","963":"faeea075"}[chunkId] + ".chunk.js";
};